import { DialogContent } from '@reach/dialog';
import PropTypes from 'prop-types';
import { useLegacyModalDialogContext } from './legacy.modal-dialog.context.js';
import { createComponent } from '../../../react/components/core/create-component.js';
import { TransitionStatus } from '../../../react/hooks/use-transition.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _object_spread_props(target, source) {
  source = source != null ? source : {};

  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var propTypes = {
  /**
  * removes the padding around the dialog's content
  */
  fullBleed: PropTypes.bool
};
/**
 * @deprecated Use new Modal/Dialog and its sub-components instead
 */

var LegacyModalDialogContent = createComponent({
  root: DialogContent,
  displayName: 'LegacyModalDialogContent',
  propTypes: propTypes,
  propConfig: {
    derivedProps: function derivedProps() {
      return useLegacyModalDialogContext();
    },
    processProps: function processProps(props, derivedProps) {
      var finalProps = _object_spread_props(_object_spread({}, props), {
        open: derivedProps.transitionState !== TransitionStatus.EXITED
      });

      if (!finalProps['aria-label'] && !finalProps['aria-labelledby']) {
        finalProps['aria-labelledby'] = derivedProps.titleId || undefined;
      }

      return finalProps;
    },
    classNames: function classNames(props, derivedProps) {
      var variant = derivedProps.variant,
          takeOver = derivedProps.takeOver,
          footerPinned = derivedProps.footerPinned,
          bodyWidth = derivedProps.bodyWidth,
          transitionState = derivedProps.transitionState;
      var fullBleed = props.fullBleed;
      var defaultClassNames = ['swan-vanilla-ignore', 'swan-legacy-modal-dialog'];
      if (fullBleed) defaultClassNames.push('swan-legacy-modal-dialog-skin-full-bleed');
      if (TransitionStatus.ENTERED === transitionState) defaultClassNames.push('swan-legacy-modal-dialog-visible');
      if (variant && ['panel-right', 'panel-left', 'panel-bottom', 'panel-top', 'menu'].includes(variant)) defaultClassNames.push('swan-legacy-modal-dialog-panel');
      if (variant && ['panel-left', 'menu'].includes(variant)) defaultClassNames.push('swan-legacy-modal-dialog-panel-left');
      if (variant && ['panel-right', 'panel-left', 'panel-bottom', 'panel-top', 'menu'].includes(variant) && bodyWidth === 'capped') defaultClassNames.push('swan-legacy-modal-dialog-panel-capped');
      if (variant === 'panel-bottom') defaultClassNames.push('swan-legacy-modal-dialog-panel-bottom');
      if (variant === 'panel-top') defaultClassNames.push('swan-legacy-modal-dialog-panel-top');
      if (variant === 'menu') defaultClassNames.push('swan-legacy-modal-dialog-panel-menu');
      if (takeOver) defaultClassNames.push('swan-legacy-modal-dialog-takeover');
      if (footerPinned) defaultClassNames.push('swan-legacy-modal-dialog-panel-pinned');
      return defaultClassNames;
    }
  }
});
export { LegacyModalDialogContent };